
export default {
  locale: 'en_US',
  // 操作：确定按钮
  okText: ('Confirm'),
  // 操作：取消按钮
  cancelText: ('Cancel'),
};